import React from 'react';
import ReactDOM from 'react-dom';

//import './css/index.scss';
import './css/index.css';
import App from './App';
import * as serviceWorker from './serviceWorker';

//import utils
import { getParamFromURI, getCookieByKey, stripTrackingParams } from './utils/formatter';

//configure({ adapter: new EnzymeAdapter() });

// Strip Google Analytics linker params (e.g. ?_gl=...) that get appended when a visitor
// arrives from another GA-tracked UC Merced site. The stray param broke the CAS auth
// redirect and produced a blank screen. Clean it from the address bar in place before
// the auth check so the redirect's `location=` and the rendered URI are both well-formed.
const cleanedURI: string = stripTrackingParams(window.location.href);
if (cleanedURI !== window.location.href) {
    window.history.replaceState(null, '', cleanedURI);
}

const URI: string = cleanedURI;

// // Collect logged in user and store in sessionStorage
// if (URI.includes('netid')) {
//     const queryParams: string[] = URI.split('?')[1].split('&');
//     sessionStorage.setItem('netid', queryParams[0].split('=')[1]);
//     sessionStorage.setItem('patronid', queryParams[1].split('=')[1]);
// }

// Enforce CAS Authentication
if (!URI.includes('netid')) {
    window.location.replace(`https://icatcard.ucmerced.edu/auth/index.php?location=${window.location.href}`);
}

let cookies = {
    patronId: getCookieByKey('patronid'),
    netId: getCookieByKey('netid'),
    firstName: getCookieByKey('firstname'),
    lastName: getCookieByKey('lastname'),
}

console.log(cookies);

ReactDOM.render(
    <React.StrictMode>
        <App
            patronid ={getParamFromURI(URI, "patronid")}
            email={getParamFromURI(URI, "netid")+"@ucmerced.edu"}
            firstName={getParamFromURI(URI, "firstname")}
            lastName={getParamFromURI(URI, "lastname")}
        />
    </React.StrictMode>,
    document.getElementById('root'),
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
